<script>
/*jshint esversion: 6 */ 
import {watch, computed, inject} from 'vue';
import './../func.common';
import { FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";
export default {
    name: 'FVisitor',
    components: {
        'font-awesome-icon' : FontAwesomeIcon,
        'font-awesome-layers' : FontAwesomeLayers,
    },
    props: {
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'id': { type: String, default: ''}, 
        'schemaId': {type: Number, default: 0}, 
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'disabled': {type: Boolean},
		'hinted': {type:String},
    },
    emits: ['validateChild'],
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
                'vTxext': props.schema.validatorText
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, { deep:true});
    }
}
</script>                
<template lang="pug"> 
.vueFormFieldMain
    .fVisitorMain.mt-4(
        :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        label(v-if="schema.label && schema.label.length > 0" v-html="schema.label") 
        template(v-for="n in schema.maxcount")
            div(:class="schema.size ? `${schema.size}`: 'col-12'")
                .fieldInput(
                    :class="schema.className"
                    :style="disabled === true ? 'cursor: not-allowed; opacity: 0.5' : ''"
                )
                    .form-group.row.gx-3-align-items-left
                        .col-sm-12 
                            label(
                                :for="id" 
                                v-if="schema.label && schema.label.length > 0"
                            ) 
                                |{{n}}. {{ schema.label }} 
                                template(v-if="n === 1")
                                    span.redAst(v-if="schema.required === true") *
                    .form-group.row.gx-3-align-items-left
                        .inputFieldMain(:class="schema.buttons ? 'col-sm-7' : 'col-sm-12'")
                            input.form-control(
                                :id="`fVisitor${n}`"
                                type="text" 
                                :name="`fVisitor${n}`"
                                :value="model[schema.model][n-1]" 
                                v-model="model[schema.model][n-1]" 
                                :class="schema.errorShow === true ? 'inputred' : ''"
                                :style="disabled === true ? 'pointer-events:none': ''"
                            )
            br
        .form-group.row.gy-2.gx-3-align-items-left
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }}
</template>